import React from "react";
import ScoreStar from "../ScoreStar";
import style from "./index.module.scss";

interface Props {
  scoreInfo: {
    comprScore: number; // 综合评分
    efficiencyScore: number; // 维保效率评分
    svcScore: number; // 服务接待评分
    qualityScore: number; // 维保质量评分
  };
}

const ScoreLine = ({ scoreInfo }: Props) => {
  return (
    <>
      {scoreInfo?.comprScore > 0 && (
        <div className={style.scoreLineComp}>
          <ScoreStar score={scoreInfo?.comprScore} showScore={false} />
        </div>
      )}
    </>
  );
};

export default ScoreLine;
